module.exports = __webpack_public_path__ + "src/app/_content/BMWFonts/BMW_iconFont.woff2?ee031e6e34e883b3cbae50d05bb6f164";